// Globals
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';

// Models
import { PropertyType } from '@/models/property.model';

// Modules
import { SettingsSidebar, StyledPageTitle } from '@/modules/SettingsCommon';

// Components
import { Spinner } from '@/ui';
import { RequiredDocumentsCard } from '../../components';
import { StyledContainer, StyledInner, StyledWrapper } from './DocumentsSettingsContainerStyles';

// Helpers
import { useGetRequiredDocuments } from '../../hooks';
import { getDocumentsSettingSidebarItems } from '../../helpers';

const DocumentsSettingsContainer = () => {
  const { t } = useTranslation('documents');
  const [searchParams, setSearchParams] = useSearchParams({
    propertyType: PropertyType.TOWNHOUSE,
  });

  const selectedPropertyType = searchParams.get('propertyType') ?? PropertyType.TOWNHOUSE;
  const { isLoading, requiredDocuments, totalRequiredDocuments } = useGetRequiredDocuments(selectedPropertyType);

  const handleChangePropertyType = (key: string) => {
    return setSearchParams((prev) => {
      prev.set('propertyType', key);
      return prev;
    });
  };

  return (
    <StyledContainer>
      <SettingsSidebar
        items={getDocumentsSettingSidebarItems(t)}
        activeKey={selectedPropertyType}
        onChange={handleChangePropertyType}
      />
      <StyledInner>
        <StyledPageTitle>
          {t('page_title_required_documents', {
            context: selectedPropertyType.toLowerCase(),
            count: totalRequiredDocuments,
          })}
        </StyledPageTitle>
        <Spinner spinning={isLoading}>
          <StyledWrapper>
            {requiredDocuments.map(([source, value]) => (
              <RequiredDocumentsCard
                key={source}
                documents={value}
                source={source}
                propertyType={selectedPropertyType}
              />
            ))}
          </StyledWrapper>
        </Spinner>
      </StyledInner>
    </StyledContainer>
  );
};

export default DocumentsSettingsContainer;
